<template>
          <Card style="height:100%">
              <p slot="title">
                  Surat Jalan Belum Di Print
              </p>
            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="3">
                    <Input
                        placeholder="Marked By"
                        clearable
                        v-model="searchUsername"
                        >
                    </Input>

                </Col>
                <Col span="20">
                    <Button type="primary"
                        clearable
                        :loading="loadingGetSuratJalan"
                        icon="ios-search-strong"
                        @click="getReadyPrint">
                        <span v-if="!loadingGetSuratJalan">Cari</span>
                        <span v-else>Wait.</span>
                    </Button>
                </Col>
            </Row>
            <br>
            <!-- <Alert
              v-show="suratJalan.length > 0"
              type="success">Showing {{suratJalanToShow.length}} from {{suratJalan.length}} Surat Jalan - Printer Location : {{serverIP}}</Alert> -->
            <br>


                <Card >

                    <Alert
                    v-show="suratJalan.length > 0"
                    type="success">Showing {{suratJalanToShow.length}} from {{suratJalan.length}} Surat Jalan - Server Location  : {{serverIP}}, Printer Name : {{this.printer.printername}}</Alert>
                    <br>

                    <!-- <Table border :columns="columnTableSuratJalan" :data="suratJalan"></Table> -->
                    <div class="flex-container">
                    <div v-for="(suratJalan, index) in suratJalan" :key="index" >
                        <div>
                            <div>
                                <font style="color: blue"> {{ suratJalan.marking }} </font>

                                <span v-if="suratJalan.isLoadingPrinted">
                                    <button style="width: 50px; background-color: yellow;" v-on:click="doPrinting(index)">Print</button>
                                </span>
                                <span v-else-if="suratJalan.isSuccessPrinted">
                                    <button style="width: 50px" v-on:click="doPrinting(index)" disabled>Print</button>
                                </span>
                                <span v-else-if="suratJalan.isErrorPrinted">
                                    <button style="width: 50px; background-color: red;" v-on:click="doPrinting(index)">Print</button>
                                </span>
                                <span v-else>
                                    <button style="width: 50px" v-on:click="doPrinting(index)">Print</button>
                                </span>

                                <hr/>
                                Marked by : {{ suratJalan.markedprintedby }} <br/>
                                Nama : {{ suratJalan.markinginfoname }} <br/>
                                Alamat Kirim 1 : {{ suratJalan.markinginfoaddress1 }}  <br/>
                                Alamat Kirim 2 : {{ suratJalan.markinginfoaddress2 }}  <br/>

                                Telepon : {{ suratJalan.markinginfophone1 }} / {{ suratJalan.markinginfophone2 }}  <br/>
                                Partai : P.{{ suratJalan.containercode }} <br/>
                                Load : {{ suratJalan.loaddate }}  <br/>
                                Volume : {{ suratJalan.volumesum }}  <br/>
                                GW : {{ suratJalan.sentctnscurrent }} <br/>
                            </div>
                        </div>
                    </div>
                    </div>


                </Card>
          </Card>

</template>
<style>
.flex-container {
  display: flex;
  flex-wrap: wrap;
}

.flex-container > div {
  overflow-y: scroll;
  background-color: #f1f1f1;
  width: 300px;
  margin: 10px;
  border: solid #CCCCCC;
  padding: 5px;
  margin: 5px;
  width: 300px;
  height: 150px;
  font-family: Arial;
  font-size: 12px;
}
</style>
<style>
    .ivu-table td.demo-table-info-column{
        background-color: #2db7f5;
        color: #fff;
    }
</style>
<script>
import {HTTP} from '@/components/http-lib'
import {SPARK} from '@/components/http-lib'

import _ from 'lodash'
import moment from 'moment'
import { RESTSERVER } from '../http-lib'
const numeral = require('numeral');


   export default {
        data () {
            return {
                suratJalan : [],
                filterResult : 50,
                searchUsername : localStorage.getItem('username'),
                jenisKertas : [
                    {
                        id : 1,
                        value : 'Pendek'
                    },
                    {
                        id : 2,
                        value : 'Panjang'
                    }
                ],
                selectedKertas : 1,
                searchCreatedDate : '',
                loadingGetSuratJalan : false,
                suratJalanToShow : [],
                serverIP : localStorage.getItem('serverUrl'),
                printer : {
                    printername : localStorage.getItem('printerName'),
                    printerIP : localStorage.getItem('printerIP')
                },
                columnTableSuratJalan: [
                    {
                        title: 'Marking Code',
                        key: 'marking',
                        align: 'center',
                    },
                    {
                        title: 'Marked By',
                        key: 'markedprintedby',
                        align: 'center',
                    },
                    {
                        title: 'Nama',
                        key: 'markinginfoname',
                        align: 'center',
                    },
                    {
                        title: 'Alamat Kirim 1',
                        key: 'markinginfoaddress1',
                        align: 'center',
                    },
                    {
                        title: 'Alamat Kirim 2',
                        key: 'markinginfoaddress2',
                        align: 'center',
                    },
                    {
                        title: 'Telepon',
                        key: 'markinginfophone',
                        align: 'center',
                    },
                    {
                        title: 'Partai',
                        key: 'partai',
                        align: 'center',
                    },
                    {
                        title: 'Load',
                        key: 'loaddate',
                        align: 'center',
                    },
                    {
                        title: 'Volume',
                        key: 'volumesum',
                        align: 'center',
                    },
                    {
                        title: 'GW',
                        key: 'sentctnscurrent',
                        align: 'center',
                    },
                    {
                        refs: 'Button',
                        title: 'Action',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            const row = params.row;
                            let classButton = 'primary';
                            const isSuccessPrinted = row.isSuccessPrinted;
                            const isErrorPrinted = row.isErrorPrinted;
                            const isLoadingPrinted = row.isLoadingPrinted;
                            let isDisabled = false;

                            if (isSuccessPrinted) {
                                classButton = 'success'
                                isDisabled = true
                            } else if (isErrorPrinted) {
                                classButton = 'error'
                                isDisabled = true
                            } else if (isLoadingPrinted) {
                                classButton = 'warning'
                                isDisabled = true
                            }

                                return h('div', [
                                h('Button', {
                                    props: {
                                        type: classButton,
                                        disabled: isDisabled
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    class: "button" + params.index,
                                    on: {
                                        click: () => {
                                            this.doPrinting(params.index)
                                        }
                                    }
                                }, 'Print')
                            ]);

                        }
                    }
                ],
            }
        },
        methods: {
            show (index) {
                console.log(this.suratJalan[index])
            },
            remove (index) {
                this.data6.splice(index, 1);
            },
            getReadyPrint: function(){
                localStorage.setItem('username', this.searchUsername)
                this.loadingGetSuratJalan = true

                if(this.searchCreatedDate != ''){
                    this.searchCreatedDate = moment(this.searchCreatedDate).format('YYYY/MM/DD')
                }

                let urlSuratJalan = 'suratJalan/0'
                if(this.searchUsername != "") {
                    urlSuratJalan = 'suratJalanByMarked/0/' + this.searchUsername
                }

              HTTP
                .get(urlSuratJalan)
                .then(response => {

                  var formattedSuratJalan = [];
                  _.forEach(response.data, function(value) {

                    if(value != null)
                    {
                        // console.log(value)
                        let markingname = value.markingname;
                        let markedprintedby  = value.markedprintedby;
                        let markinginfoname = value.markinginfoname;
                        let markinginfoaddress1 = value.markinginfoaddress1;
                        let markinginfoaddress2 = value.markinginfoaddress2;
                        let markinginfophone1 = value.markinginfophone1;
                        let markinginfophone2 = value.markinginfophone2;
                        let partai =  "P." + value.containercode;
                        let containercode = value.containercode;
                        let loaddate = value.loaddate;
                        let volumesum = value.volumesum;
                        let gwsum = value.gwsum;
                        let packaginglistid = value.packaginglistid;

                        let suratJalan = {
                                marking : markingname,
                                markedprintedby : markedprintedby,
                                markinginfoname : markinginfoname,
                                markinginfoaddress1 : markinginfoaddress1,
                                markinginfoaddress2 : markinginfoaddress2,
                                markinginfophone : markinginfophone1 + ' / ' + markinginfophone2,
                                markinginfophone1 : markinginfophone1,
                                markinginfophone2 : markinginfophone2,
                                partai : partai,
                                containercode : containercode,
                                loaddate : loaddate,
                                volumesum : volumesum,
                                sentctnscurrent : gwsum,
                                gwsum : gwsum,
                                packaginglistid : packaginglistid,
                                isSuccessPrinted : false,
                                isErrorPrinted : false,
                                isLoadingPrinted : false
                            }

                        // formattedSuratJalan = _.sortBy(formattedSuratJalan, ['markingcode']);
                        formattedSuratJalan.push(suratJalan);
                    }
                  });


                    this.suratJalan = formattedSuratJalan;
                    formattedSuratJalan = _.sortBy(formattedSuratJalan, ['markingcode']);
                    formattedSuratJalan = _.chunk(formattedSuratJalan, this.filterResult);
                    let formattedSuratJalanFirstArray = formattedSuratJalan[0]

                    if(formattedSuratJalanFirstArray != null){
                        if(formattedSuratJalanFirstArray.length > 0){
                            this.suratJalanToShow = formattedSuratJalan[0];
                        }
                    }

                    this.loadingGetSuratJalan = false
                })
                .catch(e => {
                    console.log(e)
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            doPrinting: async function(index)
            {
                // this.$refs.Button.focus()
                // console.log(index)
                if(this.printer.printername == ''){
                    this.$Notice.error({
                        title: "Nama Printer Kosong",
                        desc: "Tambahkan nama printer pada menu Setting",
                        duration: 5
                    });
                    return false;
                }

                this.suratJalan[index].printed = true;
                this.suratJalan[index];

                this.suratJalanToShow[index].printed = true;
                this.suratJalanToShow[index];

                // console.log(index)

                let textToPrint = {
                    markingcode : this.suratJalanToShow[index].marking,
                    markedprintedby : this.suratJalanToShow[index].markedprintedby,
                    markinginfoname : this.suratJalanToShow[index].markinginfoname,
                    markinginfoaddress1 : this.suratJalanToShow[index].markinginfoaddress1,
                    markinginfoaddress2 :this.suratJalanToShow[index]. markinginfoaddress2,
                    markinginfophone1 : this.suratJalanToShow[index].markinginfophone1,
                    markinginfophone2 : this.suratJalanToShow[index].markinginfophone2,
                    containercode : this.suratJalanToShow[index].containercode,
                    loaddate : this.suratJalanToShow[index].loaddate,
                    volumesum : this.suratJalanToShow[index].volumesum,
                    gwsum :this.suratJalanToShow[index].gwsum,
                    sentctnscurrent : this.suratJalanToShow[index].sentctnscurrent,
                    alamatkirim : this.suratJalanToShow[index].markinginfoaddress1,
                    printerName : localStorage.getItem('printerName'),
                    packaginglistid : this.suratJalanToShow[index].packaginglistid
                }

                // console.log(index, textToPrint)
                this.suratJalan[index].isLoadingPrinted = true;
                this.suratJalanToShow[index].isLoadingPrinted = true;
                try {
                    this.setPrint(index, textToPrint, this.suratJalanToShow[index].packaginglistid);
                } catch(e) {
                    this.$Notice.error({
                        title: "Error",
                        desc: "Pastikan koneksi internet terhubung.",
                        duration: 5
                    });
                }

            },
            setPrint: function(index, textToPrint, packaginglistid) {

                SPARK
                    .post('printSuratJalan',
                        textToPrint
                    )
                    .then(response => {
                        this.suratJalanToShow[index].isLoadingPrinted = false;
                        this.suratJalanToShow[index].isSuccessPrinted = true;
                        this.suratJalanToShow[index].isErrorPrinted = false;

                        const isPrintSuccess = response.data;
                        if(isPrintSuccess.code === "error") {
                            this.$Notice.error({
                                title: "Error Print",
                                desc: isPrintSuccess.message,
                                duration: 0
                            });
                        } else {
                            this.setSuratJalanStatus(packaginglistid)
                        }
                    })
                    .catch(e => {
                        this.suratJalanToShow[index].isLoadingPrinted = false;
                        this.suratJalanToShow[index].isSuccessPrinted = false;
                        this.suratJalanToShow[index].isErrorPrinted = true;

                        this.$Notice.error({
                            title: "Error Print",
                            desc: e + "<br/>Pastikan aplikasi printer sudah dinyalakan",
                            duration: 0
                        });
                    })
            },
            setSuratJalanStatus: function(packaginglistid){

                HTTP
                .post('suratJalan/isPrinted', {
                    packaginglistid: packaginglistid
                })
                .then(response => {
                    this.$Message.success('Surat Jalan Printed!');
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc:e,
                        duration: 5
                    });
                })
            },
        },
        mounted() {
            console.log('start..........')
            this.getReadyPrint();
        }
    }
</script>



// WEBPACK FOOTER //
// SuratJalanBelumPrint.vue?74deecf4